import { TiltUpdater } from "./TiltUpdater";
export async function loadTiltUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("tilt", (container) => new TiltUpdater(container), refresh);
}
